export const navigation = [
  { label: "首页", href: "/" },
  { label: "会员", href: "/pricing" },
  { label: "下载客户端", href: "/download" },
] as const;

export const faqItems = [
  {
    question: "云流是什么？",
    answer:
      "云流是一款面向海外华人的回国加速器，用于改善访问国内影音、音乐和国服游戏时的网络连接体验。",
  },
  {
    question: "云流支持哪些设备？",
    answer:
      "规划支持 Windows、macOS、iOS 和 Android。一个账户可以管理多台设备，具体同时在线数量以所选套餐为准。",
  },
  {
    question: "它会影响海外网站的访问速度吗？",
    answer:
      "客户端采用智能分流，只将需要回国加速的流量发送到国内线路，其他海外网站和应用保持原有网络路径。",
  },
  {
    question: "可以加速腾讯视频、爱奇艺和国服游戏吗？",
    answer:
      "产品将覆盖腾讯视频、爱奇艺、优酷、哔哩哔哩、QQ音乐、网易云音乐以及常见国服游戏。实际支持范围会随线路测试持续更新。",
  },
  {
    question: "套餐流量从什么时候开始计算？",
    answer:
      "套餐在首次启用后进入有效期。我们会在购买页和账户中心清晰展示流量、有效期与使用记录。",
  },
] as const;

export type PageMeta = {
  title: string;
  description: string;
  keywords: string;
};

export const pageMeta: Record<string, PageMeta> = {
  "/terms": { title: "用户协议｜Flux cloud 云流加速器", description: "云流服务范围、账户、套餐、连接权限、合理使用与用户权利。", keywords: "云流,用户协议,服务条款" },
  "/privacy": { title: "隐私政策｜Flux cloud 云流加速器", description: "云流账户数据、加速权限、网络元数据、信息保存及用户隐私选择。", keywords: "云流,隐私政策,个人信息" },
  "/": {
    title: "云流加速器｜海外访问国内影音、音乐与国服游戏",
    description:
      "云流加速器面向海外华人，智能加速国内影音、音乐与国服游戏，仅处理需要回国的流量。",
    keywords: "云流加速器,云流VPN,回国加速器,海外看国内视频,国服游戏加速,海外华人",
  },
  "/pricing": {
    title: "会员充值与流量包加速｜云流",
    description:
      "查看云流会员与高速流量包，了解每周期流量、购买有效期、会员设备权益与实时价格。",
    keywords: "云流会员,高速流量包,会员充值,海外华人加速器,回国加速器套餐",
  },
  "/download": {
    title: "客户端下载｜Flux cloud (云流)",
    description:
      "Flux cloud 官方客户端下载，支持 Windows、macOS、iOS、Android 与 TV 全平台。独创边缘节点加速，畅享国内网络。",
    keywords: "Flux cloud,云流加速器,回国加速器客户端,Windows加速器,Mac加速器,iOS加速器,Android加速器,TV电视端",
  },
  "/account": {
    title: "账户中心｜套餐、订单与流量权益｜云流",
      description: "登录云流账户，一键导入 Clash 订阅，查看节点实测流量、有效期、套餐权益与订单。",
    keywords: "云流VPN账户,流量套餐,订单查询",
  },
};

export const prerenderRoutes = Object.keys(pageMeta).filter((route) => route !== "/account");
